import { Disclosure, Transition } from "@headlessui/react";
import Badge from "components/molecules/Badge";
import { AuthContext } from "context/AuthContext";
import { useWindowSize } from "hooks/useWindowSize";
import { useContext, useEffect, useState } from "react";
import { BiChevronRight } from "react-icons/bi";
import { BsDashLg } from "react-icons/bs";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";

const Menu = ({ menu, sideOpen, setSideOpen, openHover, setOpenHover }) => {
  const [width] = useWindowSize();
  const { pathname } = useLocation();

  const { getTicketLoading } = useSelector((state) => state.ticket);

  const { countTicketDept, countTicketInbox } = useContext(AuthContext);
  // Fungsi untuk mencari nilai count berdasarkan status dan departement
  const findCount = (status, departement) => {
    status = status.toString();
    departement = departement.toString();

    const filteredData = countTicketDept.filter(
      (item) => item.status === status && item.departement === departement
    );

    const latestIndex = filteredData.length - 1;

    if (filteredData.length > 0) {
      return filteredData[latestIndex].count;
    }

    return 0;
  };

  let initNav = {};
  menu.forEach((level1) => {
    level1.sub.forEach((level2) => {
      if (level2.sub.length > 0) initNav[level2.name] = false;
    });
  });
  const [navopen, setNavopen] = useState(initNav);
  const navOpen = (data) => {
    setNavopen({ ...initNav, [data]: !navopen[data] });
  };

  useEffect(() => {
    if (!openHover) {
      setNavopen(initNav);
    }
  }, [openHover]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {menu.map((level1, level1Idx) => {
        if (level1.hidden === true) {
          return null;
        }
        return (
          <div key={level1Idx}>
            {/* Level 1 */}
            {level1.element && level1.sub.length === 0 && (
              <NavLink title={level1.title} key={level1Idx} to={level1.path}>
                {({ isActive }) => (
                  <div
                    className={`w-full flex items-center gap-4 p-4  ${
                      isActive
                        ? "text-sky-400 bg-sky-950 dark:text-neutral dark:bg-neutral-600"
                        : "hover:bg-sky-950 dark:hover:bg-neutral-700"
                    } ${openHover || sideOpen ? "" : "justify-center"}`}
                  >
                    <div className="flex items-center gap-4 leading-none whitespace-nowrap">
                      <div>{level1.icon}</div>
                      <span
                        className={`${openHover || sideOpen ? "" : "hidden"}`}
                      >
                        {level1.title}
                      </span>
                    </div>
                  </div>
                )}
              </NavLink>
            )}

            {!level1.element && level1.sub.length > 0 && (
              <div className="py-2">
                <div
                  className={`px-4 mb-2 text-xs flex ${
                    sideOpen || openHover ? "" : "justify-center"
                  }`}
                >
                  {sideOpen || openHover ? level1.title : <BsDashLg />}
                </div>

                {/* Level 2 */}
                {level1.sub.map((level2, level2Idx) => {
                  if (level2.hidden === true) {
                    return null;
                  }
                  if (level2.sub.length === 0) {
                    return (
                      <button
                        className="w-full"
                        disabled={getTicketLoading ? true : false}
                        key={level2Idx}
                      >
                        <NavLink
                          title={level2.title}
                          key={level2Idx}
                          to={`${level1.path}/${level2.path}`}
                        >
                          {({ isActive }) => (
                            <div
                              className={`w-full justify-between flex items-center gap-4 p-4  ${
                                isActive
                                  ? "text-sky-400 bg-sky-950 dark:text-neutral dark:bg-neutral-600"
                                  : "hover:bg-sky-950 dark:hover:bg-neutral-700"
                              } ${
                                openHover || sideOpen ? "" : "justify-center"
                              }`}
                            >
                              <div className="flex items-center gap-4 leading-none whitespace-nowrap">
                                <div>{level2.icon}</div>
                                <span
                                  className={`${
                                    openHover || sideOpen ? "" : "hidden"
                                  }`}
                                >
                                  {level2.title}
                                </span>
                              </div>
                              {/* add badge  */}
                              {level2.type === "ticket" && countTicketInbox && (
                                <Badge
                                  text={
                                    countTicketInbox.ticketinbox[level2.name]
                                  }
                                  addclass="bg-green-500 text-white"
                                />
                              )}
                            </div>
                          )}
                        </NavLink>
                      </button>
                    );
                  }

                  if (level2.sub.length > 0) {
                    return (
                      <Disclosure
                        title={level2.title}
                        as={"div"}
                        className={`relative whitespace-nowrap ${
                          pathname.split("/")[2]?.includes(level2.name)
                            ? "bg-sky-950 dark:bg-neutral-600"
                            : ""
                        }`}
                        key={level2Idx}
                      >
                        <Disclosure.Button
                          onClick={() => navOpen(level2.name)}
                          className={`w-full flex items-center p-4 ${
                            pathname.split("/")[2]?.includes(level2.name)
                              ? "text-sky-400 dark:text-neutral bg-sky-950 dark:bg-neutral-600"
                              : "hover:bg-sky-950 dark:hover:bg-neutral-700 transition-colors"
                          } ${
                            openHover || sideOpen
                              ? "justify-between"
                              : "justify-center"
                          }`}
                        >
                          <div className="flex items-center gap-4 leading-none whitespace-nowrap">
                            <div>{level2.icon}</div>
                            <span
                              className={`${
                                openHover || sideOpen ? "" : "hidden"
                              }`}
                            >
                              {level2.title}
                            </span>
                          </div>
                          {(openHover || sideOpen) && (
                            <BiChevronRight
                              size={10}
                              className={`${
                                navopen[level2.name] ? "rotate-90" : ""
                              } transition-transform`}
                            />
                          )}
                        </Disclosure.Button>
                        <Transition
                          show={navopen[level2.name]}
                          className="overflow-hidden"
                          enter="transition-[max-height] duration-500 ease-in"
                          enterFrom="max-h-0"
                          enterTo="max-h-screen"
                          leave="transition-[max-height] duration-500 ease-out"
                          leaveFrom="max-h-screen"
                          leaveTo="max-h-0"
                        >
                          {(openHover || sideOpen) && (
                            <Disclosure.Panel>
                              {level2.sub.map((level3, level3Idx) => {
                                if (level3.hidden === true) {
                                  return null;
                                }
                                return (
                                  <NavLink
                                    title={level3.title}
                                    key={level3Idx}
                                    to={`${level1.path}/${level2.path}/${level3.path}`}
                                    onClick={() => {
                                      if (width < 640) setSideOpen(false);
                                    }}
                                  >
                                    {({ isActive }) => (
                                      <div
                                        className={`flex justify-between items-center text-sm py-3 pl-[48px] px-4 transition-all ${
                                          isActive
                                            ? "text-sky-400 dark:text-neutral dark:bg-neutral-500"
                                            : "dark:hover:bg-neutral-600"
                                        } ${
                                          pathname
                                            .split("/")[1]
                                            .includes(level2.name) && sideOpen
                                            ? ""
                                            : "hover:bg-sky-950 transition-colors"
                                        }`}
                                      >
                                        <div className="flex items-center gap-4 leading-none whitespace-nowrap">
                                          <div>{level3.icon}</div>
                                          <span>{level3.title}</span>
                                        </div>
                                        {/* {level3.icon}
                                        {level3.title} */}
                                        {/* add badge  */}
                                        {level3.type === "ticket" &&
                                          findCount(
                                            level3.idStatus,
                                            level3.idDept
                                          ) !== 0 && (
                                            <Badge
                                              text={findCount(
                                                level3.idStatus,
                                                level3.idDept
                                              )}
                                              addclass="bg-green-500 text-white"
                                              key={`${level3.idStatus}-${level3.idDept}`}
                                            />
                                          )}
                                      </div>
                                    )}
                                  </NavLink>
                                );
                              })}
                            </Disclosure.Panel>
                          )}
                        </Transition>
                      </Disclosure>
                    );
                  }

                  return null;
                })}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default Menu;
